import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "o-grid u-mar-t-1" }
const _hoisted_2 = {
  class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480",
  style: {"margin-bottom":"0 !important"}
}
const _hoisted_3 = {
  key: 0,
  class: "u-form-heading unset-text-align"
}
const _hoisted_4 = {
  key: 1,
  class: "u-form-heading unset-text-align"
}
const _hoisted_5 = {
  class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200",
  style: {"margin-bottom":"0 !important"}
}
const _hoisted_6 = { class: "u-form-heading u-text-align-left u-color-primary" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "o-grid" }
const _hoisted_10 = { class: "o-grid__cell o-grid__cell--offset-3-768 o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200" }
const _hoisted_11 = { class: "gev19-premium-order-box" }
const _hoisted_12 = { class: "o-grid" }
const _hoisted_13 = { class: "o-grid__cell o-grid__cell--0 o-grid__cell--6-480" }
const _hoisted_14 = { class: "o-grid" }
const _hoisted_15 = { class: "o-grid__cell o-grid__cell--12 u-text-align-right" }
const _hoisted_16 = {
  key: 0,
  class: "o-grid__cell o-grid__cell--0 o-grid__cell--6-480 u-text-align-right"
}
const _hoisted_17 = { class: "u-form-heading unset-text-align" }
const _hoisted_18 = {
  key: 1,
  class: "o-grid__cell o-grid__cell--0 o-grid__cell--6-480 u-text-align-right"
}
const _hoisted_19 = { class: "u-form-heading unset-text-align" }
const _hoisted_20 = { class: "o-grid__cell o-grid__cell--12" }
const _hoisted_21 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Zahlweise = _resolveComponent("Zahlweise")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (
          _ctx.piniaStore.state.verkaufsprodukt !== 'BL' &&
          _ctx.piniaStore.state.verkaufsprodukt !== 'BH' &&
          !_ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state)
        )
          ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].nameProduktLinie) + "-Tarif ", 1))
          : (_openBlock(), _createElementBlock("h2", _hoisted_4, "Tarif"))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, [
          (!_ctx.piniaStore.state.isMakler)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_7, "Schließen Sie Ihren individuellen Vorschlag jetzt ab"))
            : _createCommentVNode("", true),
          (_ctx.piniaStore.state.isMakler)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_8, "Unser Vorschlag"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (
                _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].halbjaehrlich >= 25 ||
                _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].vierteljaehrlich >=
                  25 ||
                _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].monatlich >= 25
              )
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    id: "changePayment",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-zahlweise'))),
                    "data-cy": "changePaymentLink"
                  }, " Zahlungsweise ändern "))
                : _createCommentVNode("", true),
              (_ctx.istSichtbar('modal-zahlweise'))
                ? (_openBlock(), _createBlock(_component_Modal, {
                    key: 1,
                    titel: "Zahlungsweise ändern (Mindestrate 25€)",
                    onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-zahlweise')))
                  }, {
                    inhalt: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_Zahlweise, {
                          "zahlweise-feld-wert": 1,
                          "zahlweise-beitrag": 
                      _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].jaehrlich
                    ,
                          "zahlweise-text": "Jährlich"
                        }, null, 8, ["zahlweise-beitrag"]),
                        _createVNode(_component_Zahlweise, {
                          "zahlweise-feld-wert": 2,
                          "zahlweise-beitrag": 
                      _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].halbjaehrlich
                    ,
                          "zahlweise-text": "Halbjährlich"
                        }, null, 8, ["zahlweise-beitrag"]),
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--1 o-grid__cell--4-480" }, null, -1)),
                        _createVNode(_component_Zahlweise, {
                          "zahlweise-feld-wert": 4,
                          "zahlweise-beitrag": 
                      _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].vierteljaehrlich
                    ,
                          "zahlweise-text": "Vierteljährlich"
                        }, null, 8, ["zahlweise-beitrag"]),
                        _createVNode(_component_Zahlweise, {
                          "zahlweise-feld-wert": 12,
                          "zahlweise-beitrag": 
                      _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].monatlich
                    ,
                          "zahlweise-text": "Monatlich"
                        }, null, 8, ["zahlweise-beitrag"]),
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--1 o-grid__cell--4-480" }, null, -1)),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("span", {
                            id: "modalHideTariffPaymentFrequency",
                            class: "c-button",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-zahlweise'))),
                            "data-cy": "paymentFrequencySubmit"
                          }, " Änderung übernehmen ")
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.piniaStore.state.verkaufsprodukt !== 'BL' && _ctx.piniaStore.state.verkaufsprodukt !== 'BH')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createTextVNode(_toDisplayString(_ctx.piniaStore.state.isMakler === true ? "Beitrag" : "Ihr Beitrag") + " " + _toDisplayString(_ctx.textZahlungsweise ? "/" + _ctx.textZahlungsweise : "") + " ", 1),
                  _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.formatCurrency(
                  _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].gemZahlungsweise,
                )), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[8] || (_cache[8] = _createTextVNode(" Einmalbeitrag ")),
                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.formatCurrency(_ctx.piniaStore.state.preise.produktLinien[0].einmalig)), 1)
                ])),
            _cache[10] || (_cache[10] = _createElementVNode("div", null, [
              _createElementVNode("input", {
                "aria-hidden": "true",
                type: "hidden",
                class: "js-tarifOption-value",
                name: "tarifOption2",
                value: "Top"
              }),
              _createElementVNode("input", {
                "aria-hidden": "true",
                type: "hidden",
                class: "js-tarifOption-value",
                name: "tarifOption3",
                value: "Max"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                title: _ctx.piniaStore.state.isMakler === true ? 'Diesen Tarif beantragen' : 'Weiter mit diesem Tarif',
                id: "btnChooseTariffSubmit",
                class: "c-button c-button--full-width",
                "data-cy": "submitWeiterMitDiesemTarif",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nextPage()))
              }, _toDisplayString(_ctx.piniaStore.state.isMakler === true ? "Diesen Tarif beantragen" : "Weiter mit diesem Tarif"), 9, _hoisted_21)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.istSichtbar('modal-mindestbeitrag-unterschritten'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          titel: "Information",
          text: "Aufgrund Ihrer Änderungen wurde der Mindestbeitrag in Höhe von 25 € unterschritten. Die Zahlungsweise wurde daher auf jährlich umgestellt.",
          "hat-schliessen-button": true,
          onCloseModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-mindestbeitrag-unterschritten')))
        }))
      : _createCommentVNode("", true)
  ], 64))
}